var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSymulacje = function SvgSymulacje(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.16,
    height: 21.95,
    viewBox: "0 0 19.16 21.95",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_3_w\\u0142asne_symulacje"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.16,
    height: 21.95
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3_w\\u0142asne_symulacje",
    "data-name": "3 w\\u0142asne symulacje",
    clipPath: "url(#clip-_3_w\\u0142asne_symulacje)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pie-chart",
    transform: "translate(-30.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    transform: "translate(32.543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M97.988,2.743A9.6,9.6,0,0,0,84.5,2.789l-.32.32L91.268,10.2l7.041-7.132ZM91.268,8.87,85.507,3.109A8.9,8.9,0,0,1,91.268.869a8.591,8.591,0,0,1,5.715,2.195Z",
    transform: "translate(-84.181)",
    fill: "#a8b0b6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    transform: "translate(30.028 5.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M46.35,112.567l-.32-.32-6.4,6.492-6.446-6.447-.32.32a9.4,9.4,0,0,0-2.835,6.767,9.578,9.578,0,1,0,16.322-6.812Zm-6.721,15.5a8.683,8.683,0,0,1-8.687-8.687,8.556,8.556,0,0,1,2.24-5.806l6.447,6.447,6.4-6.492a8.672,8.672,0,0,1-6.4,14.539Z",
    transform: "translate(-30.028 -112.247)",
    fill: "#a8b0b6"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSymulacje, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/symulacje.891ed91a.svg";
export { ForwardRef as ReactComponent };